import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";

export default function Process() {
  const { t } = useLang();
  const steps = t("process.steps") || [];

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 bg-[#0D0D0F]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="gold-divider" />
            <span className="label-gold">{t("process.label")}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight">
            {t("process.title")}
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F2B705]/30 to-transparent pointer-events-none" />
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              data-testid={`process-step-${i}`}
              className="relative p-8 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#F2B705]/40 transition-colors"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-sm bg-[#F2B705] text-[#0A0A0A] font-display font-bold text-lg flex items-center justify-center">
                  {i + 1}
                </div>
                <div className="flex-1 h-px bg-white/10" />
              </div>
              <h3 className="font-display text-lg lg:text-xl font-semibold text-white mb-3">
                {s.t}
              </h3>
              <p className="text-sm text-neutral-400 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
